import { Button, Menu, MenuItem, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components'
import { Navigation24Regular } from '@fluentui/react-icons'
import { useState } from 'react'
import { MessagesProjectsOrganisationProject } from '@/dotnet-client/models/MessagesProjectsOrganisationProject'
import { OrganisationProjectForm } from '@/ui/Forms/OrganisationProjectForm'
import { OverlayDrawerComponent } from '@/ui/OverlayDrawerComponent/OverlayDrawerComponent'
import { MaintainProjectAdmins } from '../MaintainProjectAdmins'
import { MaintainProjectLeaders } from '../MaintainProjectLeaders'
import { isPlatformAdmin, isSuperUser } from '@/util/roles'
import { useSessionStorage } from '@/hooks/useSessionStorage'

export function RowActionsMenu({ item }: { item: MessagesProjectsOrganisationProject }) {
  const [userRole] = useSessionStorage('roles', 1)
  const [isEditProjectAllowed] = useState(() => {
    return isPlatformAdmin(userRole) || isSuperUser(userRole)
  })
  const [isMaintainProjectAdminsAllowed] = useState(() => {
    return isPlatformAdmin(userRole) || isSuperUser(userRole)
  })
  const [drawerOpen, setDrawerOpen] = useState<'none' | 'edit' | 'maintainAdmins' | 'maintainLeaders'>('none')

  return (
    <>
      <Menu>
        <MenuTrigger disableButtonEnhancement>
          <Button icon={<Navigation24Regular />} disabled={!isEditProjectAllowed || !isMaintainProjectAdminsAllowed} />
        </MenuTrigger>

        <MenuPopover>
          <MenuList>
            {isEditProjectAllowed && (
              <MenuItem
                onClick={() => {
                  setDrawerOpen('edit')
                }}
              >
                Edit project
              </MenuItem>
            )}
            {isMaintainProjectAdminsAllowed && (
              <MenuItem
                onClick={() => {
                  setDrawerOpen('maintainAdmins')
                }}
              >
                Maintain project admins
              </MenuItem>
            )}
            {isMaintainProjectAdminsAllowed && (
              <MenuItem
                onClick={() => {
                  setDrawerOpen('maintainLeaders')
                }}
              >
                Maintain project leaders
              </MenuItem>
            )}
          </MenuList>
        </MenuPopover>
      </Menu>

      <OverlayDrawerComponent
        open={drawerOpen === 'edit'}
        setOpen={(open) => setDrawerOpen(open ? 'edit' : 'none')}
        title={'Edit organisation project'}
        content={
          <OrganisationProjectForm onSubmit={() => setDrawerOpen('none')} edit selectedOrganisationProject={item} />
        }
      />

      <OverlayDrawerComponent
        key="maintainProjectAdmins"
        open={drawerOpen === 'maintainAdmins'}
        setOpen={(open) => setDrawerOpen(open ? 'maintainAdmins' : 'none')}
        size="medium"
        title={'Maintain project administrators'}
        content={<MaintainProjectAdmins selectedProject={item} />}
      />

      <OverlayDrawerComponent
        key="maintainProjectLeaders"
        open={drawerOpen === 'maintainLeaders'}
        setOpen={(open) => setDrawerOpen(open ? 'maintainLeaders' : 'none')}
        size="medium"
        title={'Maintain project leaders'}
        content={<MaintainProjectLeaders selectedProject={item} />}
      />
    </>
  )
}
